// Single place for operator/contact details used across legal pages and the footer.
export const OPERATOR_NAME = "Artists 4 Life in the Sound";
export const CONTACT_EMAIL = "thestarwall@icloud.com";
export const POLICY_EFFECTIVE = "October 6, 2026";
export const MIN_ACCOUNT_AGE = 13;
